import { ExternalLink } from "lucide-react";
import { memo } from "react";
import { Link } from "wouter";

import { getNotificationIcon } from "../lib/utils";

import { NotificationDTONotificationType } from "@/common/api";
import type { NotificationDTO } from "@/common/api/sdk";
import { Button } from "@/common/components";
import { ROUTES } from "@/common/config";
import { formatDatetime } from "@/common/lib";

interface NotificationProps {
  data: NotificationDTO;
  onMarkAsRead?: (id: string) => void;
}

export const Notification = memo(({ data, onMarkAsRead }: NotificationProps) => {
  const handleClick = () => {
    if (!data.read && data.id && onMarkAsRead) {
      onMarkAsRead(data.id);
    }
  };

  return (
    <>
      <div
        className={`border rounded-lg p-6 flex flex-col gap-3 
        transition-[color,background-color,border-color,box-shadow] hover:shadow-[0_3px_5.1px_0_#29353A26] ${
          data.read ? "bg-white border-gray-200" : "bg-blue-50 border-blue-200 shadow-sm"
        }`}
      >
        <div className="flex justify-between gap-3">
          <h4 className="flex text-Main-orange text-base font-medium leading-5">{data.title}</h4>
          {getNotificationIcon(data.notificationType)}
        </div>

        <div className="text-Text-main text-sm font-normal leading-5">{data.message}</div>

        {data.notificationType !== NotificationDTONotificationType.NOTIFICATION && (
          <div className="flex justify-between gap-3">
            <Link
              href={
                data.orderId
                  ? `${ROUTES.ORDER_ID.replace(":id", data.orderId)}?participant=1`
                  : ROUTES.ORDERS
              }
            >
              <Button variant="outline" size="sm" className="text-xs">
                <ExternalLink className="h-3 w-3 mr-1" />
                Перейти к заявке
              </Button>
            </Link>
            <p className="text-Text-secondary text-xs font-normal leading-4 flex items-center">
              {formatDatetime(data.createdAt) ?? ""}
            </p>
          </div>
        )}
      </div>
    </>
  );
});
